import script from "./GoalMilestoneWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalMilestoneWeb.vue?vue&type=script&setup=true&lang=ts"

import "./GoalMilestoneWeb.vue?vue&type=style&index=0&id=bf9137e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf9137e6"]])

export default __exports__